export enum UserRole {
  ADMIN = "ADMIN",
  STAFF = "STAFF",
}
